import { render, staticRenderFns } from "./NFCPopup.vue?vue&type=template&id=59c18e76&scoped=true"
import script from "./NFCPopup.vue?vue&type=script&lang=js"
export * from "./NFCPopup.vue?vue&type=script&lang=js"
import style0 from "./NFCPopup.vue?vue&type=style&index=0&id=59c18e76&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c18e76",
  null
  
)

export default component.exports